import React, { useState, Fragment, useEffect } from 'react';
import '../styles/Summary.scss';
import '../styles/CommonStyle.scss';
import loader from '../images/loader.gif';
import Footer from './Footer';
// import SideBarContainer from './SideBarContainer';
import SideBar from './SideBar';
import Header from './Header';
import '../styles/CommonStyle.scss';
import add_box from '../images/add_box.svg';
import spanerImg from '../images/build-black-18dp.svg';
import { getPoolInformation, getTenantLanguages } from '../services/tenant-identity-service';
import { useTranslation } from 'react-i18next';
import Modal from 'react-modal';
import close_black from '../images/close-black.svg';
import { getTokenDetailsByDecoding } from '../services/cookie-storage-service';
import { getTenantTier, getTenantProduct, getTenantPackage } from '../services/tenant-identity-service';
import { getLocation } from '../services/branch-service';
import { LicenseType } from '../enum/license-type-enum';

const Summary = (props) => {

    let [tenantData, setTenantData] = useState({});
    let [purchaseButton, setPurchaseButton] = useState("");
    let [isModalOpen, setModal] = useState(false);
    const [show, setShow] = useState(false);
    let { t } = useTranslation();
    let [locationArr, setLocations] = useState([]);
    let [languageArr, setLanguage] = useState([]);
    let [locationResult, setLocationResult] = useState([]);
    let [tierArr, setTier] = useState([]);
    let [productArr, setProduct] = useState([]);
    let [tenantPackageList, setTenantPackageList] = useState([]);
    let [pdaLicenseCount, setPDALicenseCount] = useState(0);
    let [webLicenseCount, setWebLicenseCount] = useState(0);
    let [modalFields, setModalFields] = useState(
        {
            "productGuid": "string",
            "tierGuid": "string",
            "locationGuid": "string",
            "licenseCount": 0
        }
    );

    useEffect(async () => {
        let tenantGuid = getTokenDetailsByDecoding().tenantGuid;

        getTenantDetails(tenantGuid);
        await getTenantLanguageList(tenantGuid);
        await getLocations();
        await getTenantPackageList(tenantGuid);
        await getTier();
        await getProduct();

        return () => {
            console.log('Summary ++++++++++++++++');
        };
    }, []);

    const getTenantDetails = async (tenantGuid) => {
        try {
            let tenantData = await getPoolInformation(tenantGuid);
            setTenantData(tenantData);

            if (tenantData) {
                if (tenantData.isPurchase) {
                    purchaseButton = <div className="upgrade" onClick={(e) => { navigate(e, '/Subscription_Upgrade') }}>{t('BUY NOW!')}</div>
                } else {
                    purchaseButton = <div className="upgrade" onClick={(e) => { navigate(e, '/Language') }}>{t('PURCHASE NOW!')}</div>
                }

                setPurchaseButton(purchaseButton);
            }
        } catch (error) {
            console.log('getTenantDetails error', error);
        }
    }

    const navigate = (e, path) => {
        props.history.push(path);
    }

    const handleModalClose = event => {
        setModal(false);
    };

    const handleModalOpen = event => {
        setModal(true);
    };

    const handleChange = (event) => {
        const value = { ...modalFields };
        value[event.target.name] = event.target.value;
        setModalFields(value);
    }

    const getLocations = async () => {
        try {
            let response = await getLocation();

            if (response) {
                let locationList = response.data.getBranch;
                let branchResult = locationList.map(value => {
                    return { value: value.GroupGuid, display: value.OfficeName }
                });
                let result = [{ value: '', display: 'Select Location' }].concat(branchResult);

                setLocations(result);
                setLocationResult(branchResult);
            }
        } catch (error) {
            console.log('getBranch error', error);
        }
    }

    const getTenantLanguageList = async (tenantGuid) => {
        try {
            let response = await getTenantLanguages(tenantGuid);

            if (response.length > 0) {
                let selectedLangArr = response[0].languageGuid;
                setLanguage(selectedLangArr);
            }
        } catch (error) {
            console.log('getBranch error', error);
        }
    }

    const getTier = async () => {
        try {
            let response = await getTenantTier();
            let tierFromApi = response.map(value => {
                return { value: value.TierGuid, display: value.TierName }
            });

            let resultArr = [{ value: '', display: 'Select Tier' }].concat(tierFromApi);
            setTier(resultArr);
        } catch (error) {
            console.log('getTier error', error);
        }
    }

    const getProduct = async (tenantGuid) => {
        try {
            let response = await getTenantProduct(tenantGuid);
            let productList = response.map(value => {
                return { value: value.ProductGuid, display: value.ProductName, LicenseTypeId: value.LicenseTypeId }
            });

            let productArr = [{ value: '', display: 'Select Product' }].concat(productList);
            setProduct(productArr);
        } catch (error) {
            console.log('getProduct error', error);
        }
    }

    const getTenantPackageList = async (tenantGuid) => {
        try {
            let packageList = [];
            let pdaLicenseList = [];
            let webLicenseList = [];

            packageList = await getTenantPackage(tenantGuid);

            //Calculate total license count aginst each product.
            var licenseCountArr = packageList.reduce((object, elmt) => {
                var productGuid = elmt.productGuid.toLowerCase();
                var licenseCount = elmt.licenseCount;

                if (!object.hasOwnProperty(productGuid)) {
                    object[productGuid] = licenseCount;

                } else {
                    object[productGuid] = object[productGuid] + licenseCount;
                }

                return object;
            }, []);

            var licenseCount = Object.keys(licenseCountArr).map(k => {
                return { productGuid: k, count: licenseCountArr[k] }
            });

            var packageArr = licenseCount.reduce(function (newArr, e) {
                var result = packageList.find(el => e.productGuid.toLowerCase() === el.productGuid.toLowerCase());

                if (result) {
                    newArr.push({ productGuid: e.productGuid, productName: result.productName, licenseCount: e.count });
                }

                return newArr;
            }, []);

            pdaLicenseList = packageList.filter((obj) => {
                return obj.licenseTypeId === LicenseType.PDA
            });

            webLicenseList = packageList.filter((obj) => {
                return obj.licenseTypeId === LicenseType.Web
            });

            let pdaLicenseCount = pdaLicenseList.reduce(function(prev, cur) {
                return prev + cur.licenseCount;
              }, 0);
            let webLicenseCount = webLicenseList.reduce(function(prev, cur) {
                return prev + cur.licenseCount;
              }, 0);

            setTenantPackageList(packageArr);
            setPDALicenseCount(pdaLicenseCount);
            setWebLicenseCount(webLicenseCount);
        } catch (error) {
            console.log('getPackage error', error);
        }
    }

    const increment = (event) => {
        const value = { ...modalFields };
        let oldVal = value.licenseCount;
        value['licenseCount'] = oldVal + 1;
        setModalFields(value);
    }

    const decrement = (event) => {
        const value = { ...modalFields };
        let oldVal = value.licenseCount;
        if (value.licenseCount > 0) {
            value['licenseCount'] = oldVal - 1;
        }
        else {
            value['licenseCount'] = 0;
        }

        setModalFields(value);
    }


    return (
        <main className="Dash-board">
            <div className="Dash-board-div">
                <div className="container">
                    <div className="row">
                        <div className="col-md-3">
                            <SideBar {...props} />
                        </div>
                        <div className="col-md-9">
                            <Header {...props} />
                            <div className="dash-board-content-sec">
                                {
                                    tenantData ? (
                                        <div className="summary-details">
                                            <div className="user-details">

                                                {
                                                    tenantData && tenantData.isPurchase ?
                                                        (
                                                            <Fragment>
                                                                <div className="display_flex space_between">
                                                                    <h3 className="active-subscription">{t('ACIVE SUBSCRIPTIONS')}</h3>
                                                                    <div className="add_new_purchase" onClick={handleModalOpen}><img className="margin_top_right_2" src={add_box} alt="" /><span className="color_blue muller_bold font_14 pointer">{t('New Purchase')}</span></div>
                                                                </div>
                                                                <div className="summary_package">
                                                                    <div className="row">
                                                                        <div className="col-md-6">
                                                                            <div className="added-locations">
                                                                                <div className="box">
                                                                                    <div className="align-box-elmt">
                                                                                        <h4 className="location">{t('PACKAGE - 1')}</h4>
                                                                                        <div className="spaner" href="#"><img src={spanerImg} alt="" /></div>
                                                                                    </div>
                                                                                    <div className="row">
                                                                                        <div className="col-4">
                                                                                            <p>{t('Product(s)')}</p>
                                                                                            <p>{t('Subs.Plan')}</p>
                                                                                            <p>{t('Locations')}</p>
                                                                                            <p>{t('Licenses')}</p>
                                                                                            <p>{t('Subscription')}</p>
                                                                                        </div>
                                                                                        <div className="col-8">
                                                                                            <h5>{t('3PL Warehousing')}</h5>
                                                                                            <h5>{t('SilverPulse')}</h5>
                                                                                            <h5>{t('Home-node + 3 More')}</h5>
                                                                                            <h5>{t('02 Nos')}</h5>
                                                                                            <h5 onClick={() => setShow(!show)}>{t('Monthly')}<span className="netbill">{t('(Next billing: 05/11/2021)')}</span></h5>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-6">
                                                                            <div className="added-locations">
                                                                                <div className="box">
                                                                                    <div className="align-box-elmt">
                                                                                        <h4 className="location">{t('PACKAGE - 1')}</h4>
                                                                                        <div className="spaner" href="#"><img src={spanerImg} alt="" /></div>
                                                                                    </div>
                                                                                    <div className="row">
                                                                                        <div className="col-4">
                                                                                            <p>{t('Product(s)')}</p>
                                                                                            <p>{t('Subs.Plan')}</p>
                                                                                            <p>{t('Locations')}</p>
                                                                                            <p>{t('Licenses')}</p>
                                                                                            <p>{t('Subscription')}</p>
                                                                                        </div>
                                                                                        <div className="col-8">
                                                                                            <h5>{t('Freight Forwarding')}</h5>
                                                                                            <h5>{t('GoldPulse')}</h5>
                                                                                            <h5>{t('Home-node + 2 More')}</h5>
                                                                                            <h5>{t('03 Nos')}</h5>
                                                                                            <h5 onClick={() => setShow(!show)}>{t('Monthly')}<span className="netbill">{t('(Next billing: 05/11/2021)')}</span></h5>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {show ? (
                                                                    <div className="display_flex space_between subscription_billing">
                                                                        <div className="subscr-bill">
                                                                            <p className="color-name">{t('Your Subscription has been Expired!')}</p>
                                                                            <p>{t('Renew before 10/11/2021 to continue the benefits.')}</p>
                                                                        </div>
                                                                        <div className="subscr-billing">
                                                                            <div className="upgrade pointer" onClick={() => { props.history.push('/Renews') }}>{t('RENEW')}</div>

                                                                        </div>
                                                                    </div>
                                                                ) : null}

                                                            </Fragment>
                                                        ) : (
                                                            <Fragment>
                                                                <h4 className="plans">{t('You dont have any')}<b>{t('Subscriptions')}</b>{t('yet!')}</h4>
                                                                <div className="summary-msg">{t('Before you purchase, you can configure')}<span>{t('Languages')}</span> {t('and')}<span>{t('Locations')}</span>{t('you required in your Plan.')}</div>
                                                                {purchaseButton}
                                                            </Fragment>
                                                        )
                                                }

                                                <div className="summary-text">
                                                    {/* {t('Lorem ipsum dolor sit amet, consectetuer adipiscing elit.')}
                                                        <br />
                                                        {t('Ut wisi enim ad minim veniam.')} */}
                                                </div>
                                                <h3 className="statics">{t('SUBSCRIPTION STATISTICS')}
                                                </h3>
                                                <div className="align-boxes">
                                                    <div className="boxes">
                                                        <h3>{locationResult.length}</h3>
                                                        <h6>{t('Add-on')}</h6>
                                                        <h6>{t('Locations')}</h6>
                                                    </div>
                                                    <div className="boxes">
                                                        <h3>{languageArr.length}</h3>
                                                        <h6>{t('Add-on')}</h6>
                                                        <h6>{t('Languages')}</h6>
                                                    </div>
                                                    <div className="boxes">
                                                        <h3>{tenantPackageList.length}</h3>
                                                        <h6>{t('Products')}</h6>
                                                        <h6>{t('Purchased')}</h6>
                                                    </div>
                                                    <div className="boxes">
                                                        {/* <h3>{tenantData.webLicenseCount}</h3> */}
                                                        <h3>{webLicenseCount}</h3>
                                                        <h6>{t('App')}</h6>
                                                        <h6>{t('Licenses')}</h6>
                                                    </div>
                                                    <div className="boxes">
                                                        {/* <h3>{tenantData.pdaLicenseCount}</h3> */}
                                                        <h3>{pdaLicenseCount}</h3>
                                                        <h6>{t('PDA')}</h6>
                                                        <h6>{t('Licenses')}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (<img src={loader} alt="" className="loader" />)
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>

            <Modal
                isOpen={isModalOpen}
                onRequestClose={handleModalClose}
                contentLabel="My dialog"
                style={{
                    overlay: {
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        // backgroundColor: 'rgba(0, 0, 0, 0.75)'
                    },
                    content: {
                        position: 'unset',
                        top: '40px',
                        left: '40px',
                        right: '40px',
                        bottom: '40px',
                        border: 'none',
                        background: 'none',
                        overflow: 'hidden',
                        WebkitOverflowScrolling: 'touch',
                        borderRadius: '4px',
                        outline: 'none',
                        padding: '0px'
                    }
                }}>
                <div className="modal-dialog add-new-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t('Add New Product')}</h5>
                            <button type="button" className="close" onClick={handleModalClose}>
                                <span><img src={close_black} alt="" /></span>
                            </button>
                        </div>
                        <form autoComplete="off">
                            <div className="modal-body">
                                <div className="row ">
                                    <div className="col-md-6">
                                        <label className="icon">{t('Choose Products')}</label>
                                        <select required className="form-control" name="productGuid"
                                            onChange={handleChange}>
                                            {productArr && productArr.map((elmt) => <option key={elmt.value} value={elmt.value}>{t(`${elmt.display}`)}</option>)}
                                        </select>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="icon">{t('Choose Plan')}</label>
                                        <select required className="form-control plan-selct" name="tierGuid"
                                            onChange={handleChange}>
                                            {tierArr && tierArr.map((elmt) => <option key={elmt.value} value={elmt.value}>{t(`${elmt.display}`)}</option>)}
                                        </select>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="icon">{t('Choose Location')}</label>
                                        <select required className="form-control" name="locationGuid"
                                            onChange={handleChange}>
                                            {locationArr && locationArr.map((elmt) => <option key={elmt.value} value={elmt.value}>{t(`${elmt.display}`)}</option>)}
                                        </select>
                                    </div>
                                    <div className="col-md-6 license-count-cntrl">
                                        <label>{t('Licenses required')}:</label>

                                        <input type="text" name="licenseCount" className="form-control number-count" value={modalFields.licenseCount}
                                            id="turtle-doves" onChange={handleChange} />
                                        <div className="inc button" onClick={increment}>+</div>
                                        <div className="dec button" onClick={decrement}>-</div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                {/* <div>{t('Learn more')}</div> */}
                                <button type="button" onClick={handleModalClose} className="btn btn-secondary" data-dismiss="modal">{t('CANCEL')}</button>
                                <button type="submit" className="btn btn-primary" >{t('OK')}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal>


        </main>
    )

};

export default Summary;
